import React from "react";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import {
  BadgeCheck,
  CircleX,
  Eye,
  Loader,
  MessageCircleMore,
  Send,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

// Styled component for truncated text
const TruncatedText = styled("div")(() => ({
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "&:hover": {
    cursor: "default",
  },
}));

export default function OpportunitiesItem(props) {
  const navigate = useNavigate();
  const handleApplyClick = (e) => {
    e.stopPropagation();
    props.openApplyModal(props.opportunity);
  };

  const renderActionButton = (opportunity) => {
    const baseButtonClass =
      " inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (opportunity?.application_status) {
      case "pending":
        return (
          <div className="flex gap-1">
            <span className="mt-0.5">
              <Send
                color="#15803D"
                strokeWidth={2.25}
                className="mr-2 h-5 w-5"
              />
            </span>
            <button
              className={`${baseButtonClass} ${"bg-green-100 text-green-700"}`}
            >
              Applied
            </button>
          </div>
        );

      case "rejected":
        return (
          <div className="flex gap-1">
            <span className="mt-0.5">
              <CircleX
                color="#DC2626"
                strokeWidth={2.25}
                className="mr-2 h-5 w-5"
              />
            </span>
            <button className={`${baseButtonClass} bg-red-100 text-red-600`}>
              Rejected
            </button>
          </div>
        );
      case "none":
        return (
          <div className="flex gap-1">
            <span className="mt-0.5">
              <BadgeCheck
                color="#1D4ED8"
                strokeWidth={2.25}
                className="mr-2 h-5 w-5"
              />
            </span>
            <button
              onClick={handleApplyClick}
              className={`${baseButtonClass} ${"bg-blue-100 text-blue-700"}`}
            >
              Apply Now
            </button>
          </div>
        );
      default:
        return (
          <div className="flex gap-1">
            <span className="mt-0.5">
              <Loader
                color="#4B5563"
                strokeWidth={2.25}
                className="mr-1 h-5 w-5"
              />
            </span>
            <button
              className={`${baseButtonClass} ${"bg-gray-100 text-gray-600"}`}
            >
              {opportunity?.application_status}
            </button>
          </div>
        );
    }
  };

  const getPlatformIcon = (platformCode) => {
    const id = platformCode.toString().toUpperCase();

    switch (id) {
      case "INSTAGRAM":
        return (
          <img
            src="/images/instagram.svg"
            alt="Instagram"
            width="24"
            height="24"
          />
        );
      case "TIKTOK":
        return (
          <img
            src="/images/tiktok-logo.svg"
            alt="TikTok"
            width="24"
            height="24"
          />
        );
      case "FACEBOOK":
        return (
          <img
            src="/images/facebook.svg"
            alt="Facebook"
            width="24"
            height="24"
          />
        );
      case "YOUTUBE":
        return (
          <img src="/images/youtube.svg" alt="YouTube" width="24" height="24" />
        );
      default:
        return <span>{platformCode || "NA"}</span>;
    }
  };

  const renderCellWithTooltip = (content, maxLength = 40) => {
    if (!content) return null;

    const truncated =
      content.length > maxLength
        ? `${content.substring(0, maxLength)}...`
        : content;

    return (
      <Tooltip
        title={content}
        arrow
        placement="top"
        enterDelay={0}
        leaveDelay={0}
        TransitionProps={{ timeout: 0 }}
      >
        <span className="truncate">{truncated}</span>
      </Tooltip>
    );
  };

  console.log(props.opportunity.handle.icon[0]);
  const handleChat = (e) => {
    e.stopPropagation();
    navigate(`/influencer/chat?userId=${props.opportunity.brand_profile_id}`);
  };

  const renderActionButtonStatus = (opportunity) => {
    const baseButtonClass =
      " inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (opportunity?.application_status) {
      case "pending":
        return (
          <span
            className={`${baseButtonClass} ${"bg-green-100 text-green-700"}`}
          >
            Applied
          </span>
        );

      case "rejected":
        return (
          <span className={`${baseButtonClass} bg-red-100 text-red-600`}>
            Rejected
          </span>
        );
      case "none":
        return (
          <span className={`${baseButtonClass} ${"bg-blue-100 text-blue-700"}`}>
            Not Applied
          </span>
        );
      default:
        return (
          <span className={`${baseButtonClass} ${"bg-gray-100 text-gray-600"}`}>
            {opportunity?.application_status}
          </span>
        );
    }
  };

  return (
    <TableRow onClick={props.openModal} hover className="text-gray-500">
      <TableCell className="text-center">
        {renderCellWithTooltip(
          props.opportunity.title || props.opportunity.brand_name
        )}
      </TableCell>
      <TableCell className="!text-left">
        <div className="opportunity__table-account">
          <img
            style={{ width: "28px", height: "28px", borderRadius: "50%" }}
            src={
              props.from_profile_img_url &&
              props.from_profile_img_url &&
              props.from_profile_img_url !== ""
                ? props.from_profile_img_url
                : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
            }
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
            }}
            alt="avatar"
          />{" "}
          <Tooltip
            title={props.opportunity.brand_name}
            arrow
            placement="top"
            enterDelay={0}
            leaveDelay={0}
            TransitionProps={{ timeout: 0 }}
          >
            <TruncatedText className="text-sm font-medium ml-2">
              {props.opportunity.brand_name}
            </TruncatedText>
          </Tooltip>
        </div>
      </TableCell>
      <TableCell className="!text-left">
        <Tooltip
          title={props.opportunity.deadline_date}
          arrow
          placement="top"
          enterDelay={0}
          leaveDelay={0}
          TransitionProps={{ timeout: 0 }}
        >
          <TruncatedText className="text-sm">
            {props.opportunity.deadline_date}
          </TruncatedText>
        </Tooltip>
      </TableCell>
      {props.accountCount > 1 && (
        <TableCell className="!text-left">
          <div className="opportunity__table-account">
            {getPlatformIcon(props.opportunity.handle.icon[0])}
            <Tooltip
              title={props.opportunity.handle.handle}
              arrow
              placement="top"
              enterDelay={0}
              leaveDelay={0}
              TransitionProps={{ timeout: 0 }}
            >
              <TruncatedText className="text-sm ml-1">
                {props.opportunity.handle.handle}
              </TruncatedText>
            </Tooltip>
          </div>
        </TableCell>
      )}

      <TableCell className="!text-left">
        <Tooltip
          title={props.opportunity.delivery_date}
          arrow
          placement="top"
          enterDelay={0}
          leaveDelay={0}
          TransitionProps={{ timeout: 0 }}
        >
          <TruncatedText className="text-sm">
            {props.opportunity.delivery_date}
          </TruncatedText>
        </Tooltip>
      </TableCell>

      <TableCell className="!text-left ">
        {renderCellWithTooltip(props.opportunity.budget)}
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        {renderActionButtonStatus(props.opportunity)}
      </TableCell>
      <TableCell className="!text-center !pr-12">
        <div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="p-2 text-gray-600 hover:text-blue-600 "
                onClick={(e) => e.stopPropagation()}
              >
                <MoreVertIcon />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-[180px] border border-gray-200 bg-white p-2 rounded-lg shadow-lg z-50"
            >
              {props.opportunity?.application_status === "pending" &&
              <DropdownMenuItem
                onClick={handleChat}
                className="cursor-pointer text-black font-semibold hover:bg-green-50 p-2 ml-1 rounded-md flex gap-1"
              >
                <MessageCircleMore className="mr-3 h-4 w-4" />
                Chat
              </DropdownMenuItem>}
              <DropdownMenuItem
                onClick={props.openModal}
                className="cursor-pointer hover:bg-green-50 font-semibold p-2 rounded-md flex gap-1 text-blue-600"
              >
                <Eye
                  color="#2563eb"
                  className="mr-2 h-5 w-5"
                />
                View Details
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer hover:bg-gray-50  font-semibold p-2 rounded-md flex gap-1">
                {renderActionButton(props.opportunity)}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </TableCell>
    </TableRow>
  );
}
